var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tempProposal.locked && _vm.locked)?_c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":_vm.pdf+'#view=FitH'}})]):_c('div',{staticClass:"flex justify-center mt-24"},[_c('img',{attrs:{"width":"600","src":"/images/working.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }